<div class="px-4 py-2 d-flex">
  <h2 class="d-flex gap-2">
  <a (click)="close()">
    <app-svg-icon [type]="openedFromDashboard ? 'tiles' : 'arrow-left'" size="large"/>
  </a>
   <span> {{'load.title' | translate}}</span>
  </h2>
</div>

<div class="modal-body d-flex flex-column pt-0">
  <div class="fixed-fluid flex-grow-1 flex-column px-4 pt-3">
    <div class="d-flex space-between py-3">
      <div class="d-flex flex-column gap-3">
        <ol *ngIf="visibleFeatures.breadcrumbs" class="dialog-breadcrumb activate-last m-0"
            data-testid="project-navigation-breadcrumbs">
          <li *ngIf="model.searchMode" class="d-inline">
            <app-svg-icon type="search" size="medium-small" class="d-inline pe-4"/>
            <a (click)="navigateToTopLevel()">{{ 'sidebar.search.header' | translate }}</a>
          </li>
          <ng-template ngFor let-projectGroup [ngForOf]="model.navigationChain" let-i="index">
            <li class="d-inline">
              <a href="javascript:void(0)">
                {{ getBreadcrumbLabel(projectGroup, i) }}
              </a>
            </li>
            <li *ngIf="i === 0 && model.currentFilterItem && model.currentFilterItem.name" class="d-inline">
              <a href="javascript:void(0)">
                <i class="mdi mdi-account"></i>
                {{ model.currentFilterItem.name }}
              </a>
            </li>
          </ng-template>
          <li *ngIf="model.currentViewedProjectGroup">
            <span class="project-badge">{{ model.currentViewedProjectGroup.groupName }}</span>
          </li>
        </ol>
      </div>
    </div>
    <div class="fluid d-flex flex-column overflow-scrolling-touch">
      <app-project-navigation-search
        [model]="model"
        [visibleFeatures]="visibleFeatures"
        (searchEvent)="performSearch($event)"/>

      <div *ngIf="model.viewItems && model.viewItems.length != 0" class="label-headers font-weight-bold information-label d-flex gap-2">
        <span style="width: 18.6%"></span>
        <span style="width: 16%">{{ 'projectNavigation.label.modification_by' | translate }}</span>
        <span style="width: 15.3%">{{ 'projectNavigation.label.sorting_article_number' | translate }}</span>
        <span style="width: 16%">{{ 'projectNavigation.label.modification_date' | translate }}</span>
        <span>{{ 'projectNavigation.label.status' | translate }}</span>
      </div>

      <app-project-navigation-result
        class="d-flex flex-grow-1"
        [model]="model"
        [visibleFeatures]="visibleFeatures"
        [selectionAvailable]="false"
        [showHiddenItems]="showHiddenItems"
        [multipleSelectionWithinSingleProject]="multipleSelectionWithinSingleProject"
        [isNewProjectCreation]="isNewProjectCreation"
        (cancel)="finish.emit()"
        (actionButtonClick)="loadProject()"
        (submitEnabled)="updateSubmitEnabled()"
        (openFolder)="openFolder($event)"
        (openProject)="openProject($event)"
        (updateViewItems)="updateViewItems()"
        [isConstruction]="true" />
    </div>
  </div>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-secondary btn-cancel" (click)="close()">{{'global.label.cancel' | translate}}</button>
  <button type="button" class="btn btn-primary btn-forward" (click)="loadProject()" [class.event-disabled]="!submitEnabled" [disabled]="!submitEnabled">
    {{'load.label.load' | translate}}
  </button>
</div>
